import Icon from '@material-ui/icons/Label'
import React from 'react'
import {
    Create,
    Datagrid,
    DeleteButton,
    Edit,
    EditButton,
    Filter,
    List,
    required,
    SearchInput,
    SimpleForm,
    TextField as TextFieldRa,
    TextInput
} from 'react-admin'

export const ProductTagIcon = Icon

const ProductTagFilter = props => (
    <Filter {...props}>
        <SearchInput source="q" alwaysOn />
    </Filter>
)
export const ProductTagList = ({ permissions, ...props }) => {
    return (
        <List {...props} exporter={false} title="ProductTags" bulkActionButtons={false} sort={{ field: 'name', order: 'ASC' }} filters={<ProductTagFilter />} perPage={25}>
            <Datagrid>
                <TextFieldRa source="name" label="Nome" />
                <EditButton label="" />
                <DeleteButton label="" />
            </Datagrid>
        </List>
    )
}


export const ProductTagEdit = (props) => {
    return (
        <Edit {...props}>
            <SimpleForm redirect="list">
                <TextInput disabled label="Código" source="id" />
                <TextInput label="Nome" source="name" validate={validateName} />
            </SimpleForm>
        </Edit>
    )
}

const validateName= [required()]
export const ProductTagCreate = (props) => {
    return (
        <Create {...props}>
            <SimpleForm redirect="list">
                <TextInput label="Nome" source="name" validate={validateName} />
            </SimpleForm>
        </Create>
    )
}
